import { ErrorTracker } from '@/modules/error-logger/domain/ErrorTracker';
import { resolve } from '@/core/di';
import { TrackingClientToken } from '@/modules/error-logger/di/tokens';
import type { TrackingClient } from '@/modules/error-logger/domain/TrackingClient';

export const errorTracker = (): ErrorTracker => resolve(ErrorTracker);
export const trackingClient = (): TrackingClient => resolve(TrackingClientToken);
